import { css } from '@emotion/react';

import { breakpoints, typography2 } from '@coursera/cds-core';

export const compactBlockStyle = css`
  padding: 48px 0;

  ${breakpoints.down('sm')} {
    padding: 32px 0;
  }
`;

export const sharedMarkdownStyles = css`
  * {
    /* stylelint-disable-next-line cds-stylelint/cds-typography-utility */
    font-family: var(--cds-font-family-source-sans-pro) !important;
    color: inherit !important;
  }

  p {
    ${typography2.bodyPrimary}
    font-size: 20px !important;
    line-height: 150% !important;
    letter-spacing: -0.02em !important;
    min-height: 1rem !important;
  }

  h1 {
    font: ${typography2.titleLarge.font} !important;
    letter-spacing: ${typography2.titleLarge.letterSpacing} !important;
  }

  h2 {
    font: ${typography2.titleMedium.font} !important;
    letter-spacing: ${typography2.titleMedium.letterSpacing} !important;
  }

  h3 {
    ${typography2.titleSmall}
    font-size: 28px !important;
    font-weight: 600 !important;
  }

  h4 {
    ${typography2.subtitleLarge}
    font-size: 24px !important;
    font-weight: 600 !important;
  }

  h5 {
    ${typography2.subtitleMedium}
    font-size: 22px !important;
    font-weight: 600 !important;
  }

  h6 {
    ${typography2.subtitleMedium}
    font-size: 20px !important;
    font-weight: 600 !important;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: normal !important;
    letter-spacing: -0.03em !important;
  }
`;
